import { GA_MEASUREMENT_ID } from '../constants/branding';

let analyticsLoadStarted = false;

/**
 * Charge GA4 après le first paint pour ne pas bloquer FCP/LCP mobile.
 */
export function loadGoogleAnalytics() {
  if (analyticsLoadStarted || typeof window === 'undefined') {
    return;
  }
  analyticsLoadStarted = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  const analyticsScript = document.createElement('script');
  analyticsScript.async = true;
  analyticsScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(analyticsScript);
}

export function scheduleGoogleAnalyticsLoad() {
  if (typeof window === 'undefined') {
    return;
  }

  const loadWhenIdle = () => loadGoogleAnalytics();

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadWhenIdle, { timeout: 3500 });
    return;
  }

  window.addEventListener('load', () => {
    window.setTimeout(loadWhenIdle, 1500);
  }, { once: true });
}
